// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ResponseStepPhase = {
  StepPhasePending: 'Pending',
  StepPhaseWaiting: 'Waiting',
  StepPhaseTransferring: 'Transferring',
  StepPhaseCoolingDown: 'CoolingDown',
  StepPhaseCompleted: 'Completed',
} as const;
export type ResponseStepPhase =
  (typeof ResponseStepPhase)[keyof typeof ResponseStepPhase];

export function instanceOfResponseStepPhase(value: any): boolean {
  for (const key in ResponseStepPhase) {
    if (Object.prototype.hasOwnProperty.call(ResponseStepPhase, key)) {
      if (ResponseStepPhase[key as keyof typeof ResponseStepPhase] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ResponseStepPhaseFromJSON(json: any): ResponseStepPhase {
  return ResponseStepPhaseFromJSONTyped(json, false);
}

export function ResponseStepPhaseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseStepPhase {
  return json as ResponseStepPhase;
}

export function ResponseStepPhaseToJSON(value?: ResponseStepPhase | null): any {
  return value as any;
}

export function ResponseStepPhaseToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ResponseStepPhase {
  return value as ResponseStepPhase;
}
